import { User } from '@/types/common.type'
import { createSlice } from '@reduxjs/toolkit'
import { isEmpty } from 'lodash'

type State = {
  auth: any
  user: User | null
  loading: boolean
  logOutLoading: boolean
  permissions: string[]
}

const initialState: State = {
  auth: null,
  user: null,
  loading: true,
  logOutLoading: false,
  permissions: []
}

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    onGetUserInfo: (state, action) => {
      state.user = action.payload
      state.loading = isEmpty(action.payload)
    },
    onGetPermissions: (state, action) => {
      state.permissions = action.payload
      state.loading = isEmpty(action.payload)
    }
  },
  extraReducers: () => {}
})

export const { onGetUserInfo, onGetPermissions } = authSlice.actions
export const selectUser = (state: State) => state.auth.user
export const selectPermissions = (state: State) => state.auth.permissions

const authReducer = authSlice.reducer
export default authReducer
